import React, { useState, useEffect } from 'react';
import { Tab, Nav, Container } from 'react-bootstrap';
import LoginForm from '../components/Form/LoginForm'; // Importando o formulário de login
import RegistroForm from '../components/Form/RegistroForm'; // Importando o formulário de registro
import RenderizarFoto from '../components/Utils/RenderizarFoto'; // Importando o formulário de registro
import { useNavigate } from 'react-router-dom';
import InstalarApp from '../components/Button/InstalarApp';
import AbrirApp from '../components/Button/AbrirApp'
import { useProvider } from '../context/MenuProvider'
import ImageCropper from '../components/Utils/ImageCropper';

const Login = () => {
  const { site } = useProvider();
  const [formType, setFormType] = useState('login');
  const navigate = useNavigate();
  
  return (
    <Container className={`mt-5 mx-auto ${formType==="login"&&"col-md-5"} ${formType==="register"&&"col-md-7"}`}>
      <div className="text-center my-2 mx-auto">
          <ImageCropper foto={`https://${site?.domain}${site?.favicon}`} so_exibe={true} radius={50} width={500} height={500} />
          {/*
          <RenderizarFoto className="rounded-pill border" width="120" alt="Logomarca" src={`${site?.favicon}`} />
          */}
      </div>
      {site?.empresa && (
        <LoginForm />
      )}
      {!site?.empresa && (
        <>
          <Tab.Container id="login-register-tabs" activeKey={formType} onSelect={(k) => setFormType(k)}>
            <Nav variant="tabs" className="justify-content-center">
              <Nav.Item>
                <Nav.Link eventKey="login">Login</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="register">Criar conta</Nav.Link>
              </Nav.Item>
            </Nav>
    
            <Tab.Content className="border">
              {/* Painel de Login */}
              {formType === 'login' && <LoginForm />}
              {/* Painel de Registro */}
              {formType === 'register' && <RegistroForm />}
            </Tab.Content>
          </Tab.Container>
        </>
      )}
      <AbrirApp />
    </Container>
  );
};

export default Login;